import {
  PF_WIDGET_FREEZE_TABLE_GROUPED_DEFAULT,
  PF_WIDGET_FREEZE_TABLE_NORMAL_DEFAULT,
  WIDGET_FREEZE_TABLE_KEY_BY_TEMPLATE_ID,
} from '../constants/widget-freeze-table-key.constant';

function coerceTemplateId(widgetDetails) {
  const raw =
    widgetDetails?.widget_template_id ??
    widgetDetails?.widget_template?.widget_template_id;
  if (raw === undefined || raw === null) return null;
  const s = String(raw).trim();
  return s === '' ? null : s;
}

export function getWidgetFreezeTableKey(widgetDetails, variant = 'grouped') {
  const tid = coerceTemplateId(widgetDetails);
  const map = WIDGET_FREEZE_TABLE_KEY_BY_TEMPLATE_ID;
  if (tid != null && Object.prototype.hasOwnProperty.call(map, tid)) {
    return map[tid];
  }
  if (tid != null) {
    const n = Number(tid);
    if (Number.isFinite(n) && Object.prototype.hasOwnProperty.call(map, n)) {
      return map[n];
    }
  }
  return variant === 'grouped'
    ? PF_WIDGET_FREEZE_TABLE_GROUPED_DEFAULT
    : PF_WIDGET_FREEZE_TABLE_NORMAL_DEFAULT;
}

export const buildWidgetFreezeTableKey = getWidgetFreezeTableKey;
